module.exports = __webpack_public_path__ + "img/img7.a02daa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img7.png
// module id = 271
// module chunks = 0